<template>
  <div class="check-auth">
    <p>
      <img :src="authChecked ? 'https://aliimg.changba.com/!/activity2023/come_sing_with_me/checkbox_active.png' : 'https://aliimg.changba.com/!/activity2023/come_sing_with_me/checkbox_inactive.png'" :alt="authChecked ? '同意授权' : '不同意授权'" @click="toggleAuth" />
      参与活动需先同意作品
      <span class="open" @click="checkAuth">使用授权</span>
    </p>
  </div>
</template>

<script>
import { getGlobalParams } from "@changba/funny";

export default {
  name: "CheckAuth",
  computed: {
    authChecked() {
      return this.$store.state.authChecked;
    },
  },
  methods: {
    checkAuth() {
      this.$openDialog("AuthDialog");
    },
    async toggleAuth() {
      const params = await getGlobalParams();
      this.$store.commit("toggleAuthChecked", {
        status: this.authChecked === 0 ? 1 : 0,
        userid: params.userId,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.check-auth {
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("../assets/footer-bg.png");
  background-size: contain;
  background-position: center center;

  p {
    font-size: 24px;
    line-height: 37px;
    color: #f7deff;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 37px;
      height: 37px;
      margin-right: 10px;
    }
    .open {
      color: #ff71eb;
    }
  }
}
</style>
